/**
 * RouterPathManager API Service
 * 统一管理路由路径管理相关的API调用
 */

import {
  routerList,
  routerSaveOrUpdate,
  routerDelete,
} from '@/services/technical';
import $x from '@/utils/$x';

// 移除所有模拟数据，确保接口使用真实数据

// 路由管理相关接口
const getRouterListApi = (params) => routerList(params);
const saveOrUpdateRouterApi = (params) => routerSaveOrUpdate(params);
const deleteRouterApi = (params) => routerDelete(params);

// 新增路由相关接口
// 获取路由列表接口
export async function getProductRouteListApi(params) {
  return $x.post(`/product/route/list`, params);
}

// 获取路由详情接口
export async function getProductRouteDetailsApi(params) {
  return $x.post(`/product/route/details`, params);
}

// 保存或更新路由接口
export async function saveOrUpdateRouteApi(params) {
  return $x.post(`/product/route/saveOrUpdate`, params);
}

// 删除路由接口
export async function deleteProductRouteApi(params) {
  return $x.post(`/product/route/del`, params);
}
// 路由总览分页接口（整合所有路由）
export async function getAllRoutePageListApi(params) {
  return $x.post(`/product/route/list`, params);
}
// 查询产品线路由基本信息
export async function getRouteWidthLine(params) {
  return $x.post(`/product/route/base/list`, params);
}
// 产品模块管理相关接口已移至真实接口实现

// 知识库管理相关接口
// 获取产品目录分类
export async function getProductLineCategoryApi(params) {
  return $x.post(`/product/line/category`, params);
}

// 新增或更新产品线
export async function saveOrUpdateProductLineApi(params) {
  return $x.post(`/product/line/saveOrUpdate`, params);
}

// 分页查询产品线接口
export async function getProductLinePageListApi(params) {
  return $x.post(`/product/line/list`, params);
}

// 获取产品线详情接口
export async function getProductLineDetailsApi(params) {
  return $x.post(`/product/line/details`, params);
}

// 删除产品线接口
export async function deleteProductLineApi(params) {
  return $x.post(`/product/line/del`, params);
}

// 配置产品线知识库接口
export async function setupProductLineKnowledgeApi(params) {
  return $x.post(`/product/line/setup/knowledge`, params);
}

// 同步产品线知识库接口
export async function syncProductLineKnowledgeApi(params) {
  return $x.post(`/product/line/sync/knowledge`, params);
}
// 查询产品线下的模块基本信息
export async function getModuleWidthProductLine(params) {
  return $x.post(`/product/module/base/list`, params);
}

// 分页查询产品模块接口
export async function getProductModulePageListApi(params) {
  return $x.post(`/product/module/list`, params);
}

// 获取产品模块详情接口
export async function getProductModuleDetailsApi(params) {
  return $x.post(`/product/module/details`, params);
}

// 新增或更新产品模块接口
export async function saveOrUpdateProductModuleApi(params) {
  return $x.post(`/product/module/saveOrUpdate`, params);
}

// 删除产品模块接口
export async function deleteProductModuleApi(params) {
  return $x.post(`/product/module/del`, params);
}

// 生成知识库接口
export async function generateKnowledgeBaseApi(params) {
  return $x.post(`/knowledge/base/generate`, params);
}

// 导出知识库接口
export async function exportKnowledgeBaseApi(params) {
  return $x.post(`/knowledge/base/export`, params);
}

// 简化的API调用函数，移除错误处理
export const handleApiCall = async (apiCall) => {
  return await apiCall();
};

// 导出API对象，保持原有接口结构
export const routerApi = {
  getRouterList: getRouterListApi,
  saveOrUpdateRouter: saveOrUpdateRouterApi,
  deleteRouter: deleteRouterApi,
  // 新增路由接口
  getProductRouteList: getProductRouteListApi,
  getProductRouteDetails: getProductRouteDetailsApi,
  saveOrUpdateRoute: saveOrUpdateRouteApi,
  deleteProductRoute: deleteProductRouteApi,
  getAllRoutePageList: getAllRoutePageListApi,
};

export const productLineApi = {
  getProductLinePageList: getProductLinePageListApi,
  saveOrUpdateProductLine: saveOrUpdateProductLineApi,
  getProductLineDetails: getProductLineDetailsApi,
  deleteProductLine: deleteProductLineApi,
  setupProductLineKnowledge: setupProductLineKnowledgeApi,
};

export const productModuleApi = {
  getProductModulePageList: getProductModulePageListApi,
  getProductModuleDetails: getProductModuleDetailsApi,
  saveOrUpdateProductModule: saveOrUpdateProductModuleApi,
  deleteProductModule: deleteProductModuleApi,
};

export const knowledgeBaseApi = {
  generateKnowledgeBase: generateKnowledgeBaseApi,
  exportKnowledgeBase: exportKnowledgeBaseApi,
};

export const productLineCategoryApi = {
  getProductLineCategory: getProductLineCategoryApi,
};

// 简化的错误分类函数
export const classifyError = (error) => {
  if (!error) return 'unknown';

  const status = error.status || error.response?.status;
  const message = error.message || error.response?.data?.message || '';

  if (status === 401) return 'auth';
  if (status === 403) return 'permission';
  if (status === 404) return 'notFound';
  if (status >= 500) return 'server';
  if (message.includes('网络') || message.includes('timeout')) return 'network';

  return 'business';
};

// 统一导出所有API
export default {
  router: routerApi,
  productLine: productLineApi,
  productModule: productModuleApi,
  knowledgeBase: knowledgeBaseApi,
  productLineCategory: productLineCategoryApi,
};
